import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponse, Pagination, Response } from '../_models/response.model';
import { IApprovalsTypes, IPatientApprovalsDetails } from '../_interfaces/approvals/lcaPatientApprovals.interface';

@Injectable({
  providedIn: 'root'
})
export class PatientsApprovalsService {

  getApprovalsFileTypeUrl: string = 'api/AdminLcaApprovals/GetFileTypeForLcaApprovals'
  getAllLcaApprovlsUrl: string = 'api/AdminLcaApprovals/GetLcaApprovalFilesByPatientId'
  uploadLcaApprovalFilesUrl: string = 'api/AdminLcaApprovals/UploadLcaApprovalFile'

  constructor(private http: HttpClient) { }

  getPatientApprovals(patientId, currentPage, pageSize): Observable<GenericResponse<{ items: IPatientApprovalsDetails[]; pagination: Pagination }>> {
    let params = new HttpParams()
      .set('PatientId', patientId)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize)
    return this.http.get<GenericResponse<{ items: IPatientApprovalsDetails[]; pagination: Pagination }>>(this.getAllLcaApprovlsUrl, { params: params });
  }

  getApprovalsTypes(): Observable<GenericResponse<IApprovalsTypes[]>> {
    return this.http.get<GenericResponse<IApprovalsTypes[]>>(this.getApprovalsFileTypeUrl)
  }

  uploadLcaApprovalData(patientApprovalData: FormData): Observable<GenericResponse<IPatientApprovalsDetails>> {
    return this.http.post<GenericResponse<IPatientApprovalsDetails>>(this.uploadLcaApprovalFilesUrl, patientApprovalData)
  }

}

